module.exports = __webpack_public_path__ + "img/affiliate_purple.5edf509a.svg";